import type { DaycareHotelMode } from "@/hooks/useDaycareHotelAccess";

export function getStayReportPath() {
  return "/reports/daycare-hotel";
}

export function getStayReportTabKey(mode: DaycareHotelMode) {
  if (mode === "daycare") return "tabDaycare" as const;
  if (mode === "hotel") return "tabHotel" as const;
  return "tabDaycareHotel" as const;
}
